(function () {
  function init(root) {
    if (!root || root.dataset.gfReady) return;
    root.dataset.gfReady = '1';

    var state = { occasion: null, recipient: null, category: null };
    var labels = { occasion: '', recipient: '', category: '' };

    var panels = {
      1: root.querySelector('[data-gf-panel="1"]'),
      2: root.querySelector('[data-gf-panel="2"]'),
      3: root.querySelector('[data-gf-panel="3"]')
    };
    var result = root.querySelector('[data-gf-result]');
    var summary = root.querySelector('[data-gf-summary]');
    var cta = root.querySelector('[data-gf-cta]');
    var tabs = root.querySelectorAll('[data-gf-step-tab]');

    function showPanel(n) {
      Object.keys(panels).forEach(function (k) {
        var p = panels[k];
        if (!p) return;
        var on = String(k) === String(n);
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
      if (result) {
        result.hidden = true;
      }
      tabs.forEach(function (t) {
        var step = Number(t.getAttribute('data-gf-step-tab'));
        t.classList.toggle('is-active', step === n);
        t.classList.toggle('is-done', step < n);
        t.disabled = step > n;
      });
    }

    function finish() {
      Object.keys(panels).forEach(function (k) {
        if (panels[k]) {
          panels[k].hidden = true;
          panels[k].classList.remove('is-active');
        }
      });
      if (result) result.hidden = false;
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.classList.add('is-done');
        t.disabled = false;
      });
      // Prefer most specific collection: category > recipient > occasion
      var handle = state.category || state.recipient || state.occasion || 'new-arrivals';
      if (summary) {
        summary.textContent =
          'You picked: ' +
          [labels.occasion, labels.recipient, labels.category].filter(Boolean).join(' · ');
      }
      if (cta) {
        cta.href = '/collections/' + handle;
      }
    }

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-gf-pick]');
      if (pick) {
        var type = pick.getAttribute('data-gf-pick');
        var value = pick.getAttribute('data-gf-value');
        var label = pick.getAttribute('data-gf-label') || value;
        state[type] = value;
        labels[type] = label;
        pick.parentElement.querySelectorAll('[data-gf-pick]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        pick.classList.add('is-selected');
        if (type === 'occasion') showPanel(2);
        else if (type === 'recipient') showPanel(3);
        else finish();
        return;
      }
      if (e.target.closest('[data-gf-back]')) {
        if (!panels[3].hidden) showPanel(2);
        else if (!panels[2].hidden) showPanel(1);
        return;
      }
      if (e.target.closest('[data-gf-reset]')) {
        state = { occasion: null, recipient: null, category: null };
        labels = { occasion: '', recipient: '', category: '' };
        root.querySelectorAll('.luth-gf__card.is-selected').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        showPanel(1);
      }
    });

    showPanel(1);
  }

  document.querySelectorAll('[data-luth-gift-finder]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-luth-gift-finder]');
    if (el) {
      delete el.dataset.gfReady;
      init(el);
    }
  });
})();
